// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"backToTop_backToTop__25G60"};